import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

import { ProductDetailsContext } from '../../../context';

import { messages } from '../../../messages';
import generalStyle from '../../../style.module.less';
import Global from '../../../../../store/global-selectors';
import style from './style.module.less';

export const Admin = () => {
  const { modifiedDateUtc, productId, createDateUtc, hasHadInventory } = useContext(ProductDetailsContext);

  const userDateFormat = useSelector(Global.selectUserUserDateFormat);
  const userTimeFormat = useSelector(Global.selectUserUserTimeFormat);
  const dateTimeFormat = `${userDateFormat} ${userTimeFormat}`;

  const formattedCreateDate = createDateUtc ? `${moment(createDateUtc).format(dateTimeFormat)} UTC` : '';
  const formattedModifiedDate = modifiedDateUtc ? `${moment(modifiedDateUtc).format(dateTimeFormat)} UTC` : '';

  return (
    <>
      <div className={generalStyle['shipping-defaults-header-wrapper']}>
        <div className={generalStyle['shipping-defaults-header-text']}>
          <FormattedMessage {...messages.adminHeader} />
        </div>
      </div>
      <div className={style.wrapper}>
        <div className={generalStyle['rightside-label']}>
          <FormattedMessage {...messages.productId} />
        </div>
        <div className={style.value}>{productId}</div>
        <div className={generalStyle['rightside-label']}>
          <FormattedMessage {...messages.createDate} />
        </div>
        <div className={style.value}>{formattedCreateDate}</div>
        <div className={generalStyle['rightside-label']}>
          <FormattedMessage {...messages.modifiedDate} />
        </div>
        <div className={style.value}>{formattedModifiedDate}</div>
        <div className={generalStyle['rightside-label']}>
          <FormattedMessage {...messages.hasHadInventory} />
        </div>
        <div className={style.value}>{hasHadInventory && hasHadInventory.toString()}</div>
      </div>
    </>
  );
};
